<template>
    <div>
        <!-- Popup Detalle NC Perseo -->
        <vs-popup
            title="Detalle Nota de Crédito Perseo"
            :active.sync="showModalNCPerseo"
        >
            <div class="p-4" v-if="ncPerseoData">
                <div class="mb-4 p-3 bg-blue-50 border-l-4 border-blue-500">
                    <p class="text-sm"><strong>NC:</strong> {{ ncPerseoData.establecimiento }}-{{ ncPerseoData.puntoemision }}-{{ ncPerseoData.secuencial }}</p>
                    <p class="text-sm"><strong>Emisión:</strong> {{ ncPerseoData.emision }}</p>
                    <p class="text-sm"><strong>Cliente:</strong> {{ ncPerseoData.razonsocial }} ({{ ncPerseoData.identificacion }})</p>
                </div>

                <table class="w-full table-auto mb-4">
                    <thead>
                        <tr class="bg-gray-100">
                            <th class="px-3 py-2 text-left text-xs">Producto</th>
                            <th class="px-3 py-2 text-center text-xs">Cant.</th>
                            <th class="px-3 py-2 text-right text-xs">Precio</th>
                            <th class="px-3 py-2 text-right text-xs">Desc.</th>
                            <th class="px-3 py-2 text-right text-xs">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(det, idx) in (ncPerseoData.facturasd && ncPerseoData.facturasd.detalles ? ncPerseoData.facturasd.detalles : [])" :key="idx" class="border-b">
                            <td class="px-3 py-2 text-xs">
                                {{ det.nombreproducto }}<br>
                                <span class="text-gray-500">{{ det.productocodigo }}</span>
                            </td>
                            <td class="px-3 py-2 text-center text-xs">{{ parseFloat(det.cantidad || 0).toFixed(2) }}</td>
                            <td class="px-3 py-2 text-right text-xs">${{ parseFloat(det.precio || 0).toFixed(2) }}</td>
                            <td class="px-3 py-2 text-right text-xs">{{ parseFloat(det.descuento || 0).toFixed(2) }}%</td>
                            <td class="px-3 py-2 text-right text-xs font-bold">${{ ((parseFloat(det.cantidad || 0) * parseFloat(det.precio || 0)) * (1 - parseFloat(det.descuento || 0) / 100)).toFixed(2) }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="p-3 bg-gray-50 rounded">
                    <div class="flex justify-between mb-2 text-sm">
                        <span>Subtotal:</span>
                        <strong>${{ parseFloat(ncPerseoData.subtotal || 0).toFixed(2) }}</strong>
                    </div>
                    <div class="flex justify-between mb-2 text-sm">
                        <span>Descuento:</span>
                        <strong>${{ parseFloat(ncPerseoData.total_descuento || 0).toFixed(2) }}</strong>
                    </div>
                    <div class="flex justify-between mb-2 text-sm">
                        <span>IVA:</span>
                        <strong>${{ parseFloat(ncPerseoData.total_iva || 0).toFixed(2) }}</strong>
                    </div>
                    <div class="flex justify-between pt-2 border-t-2 border-gray-300 text-base">
                        <span class="font-bold">Total:</span>
                        <strong class="text-green-600">${{ parseFloat(ncPerseoData.total || 0).toFixed(2) }}</strong>
                    </div>
                </div>
            </div>
        </vs-popup>

        <!-- Popup Detalle Devolución -->
        <vs-popup
            title="Detalle Devolución"
            :active.sync="showModalDevolucion"
            fullscreen
        >
            <div class="p-4">
                <div v-if="devolucionSeleccionada" class="mb-4">
                    <div class="flex items-center justify-between flex-wrap gap-2">
                        <div>
                            <h4 class="font-bold text-primary mb-1">{{ devolucionSeleccionada.ven_codigo }}</h4>
                            <p class="text-sm text-gray-600">Contrato: {{ devolucionSeleccionada.contrato || devolucionSeleccionada.contrato_generado || '—' }}</p>
                            <p class="text-sm text-gray-600">Factura Perseo: {{ devolucionSeleccionada.factura_perseo || '—' }}</p>
                            <p class="text-sm text-gray-600">Nota Crédito: {{ devolucionSeleccionada.nota_credito || '—' }}</p>
                            <p v-if="devolucionSeleccionada.nota_credito" :class="estadoNCClase">
                                Estado NC: {{ estadoNC }}
                            </p>
                            <!-- <p class="text-sm text-gray-600 mt-2">ID Factura Perseo: {{ devolucionSeleccionada.id_factura_perseo || '—' }}</p> -->
                            <!-- <p class="text-sm text-gray-600">ID NC Perseo: {{ devolucionSeleccionada.id_nota_credito_perseo || '—' }}</p> -->
                        </div>
                        <div class="flex gap-2 flex-wrap justify-end">
                            <vs-button
                                v-if="!ncYaGenerada"
                                color="warning"
                                :disabled="loadingGenerarNC"
                                @click="previsualizarNotaCreditoDevolucion"
                            >
                                {{ loadingGenerarNC ? 'Procesando...' : 'Vista previa NC' }}
                            </vs-button>
                            <vs-button
                                v-if="!ncYaGenerada"
                                color="success"
                                :disabled="loadingGenerarNC"
                                @click="generarNotaCreditoDevolucion"
                            >
                                {{ loadingGenerarNC ? 'Generando...' : 'Generar Nota de Crédito' }}
                            </vs-button>
                            <vs-button
                                v-if="ncYaGenerada && userRoot && !ncEnviadaAPerseo"
                                color="info"
                                :disabled="loadingGenerarNC"
                                @click="enviarNCAPerseo"
                            >
                                {{ loadingGenerarNC ? 'Enviando...' : 'Enviar NC a Perseo' }}
                            </vs-button>
                            <vs-button
                                v-if="ncEnviadaAPerseo"
                                color="success"
                                disabled
                            >
                                ✓ NC Enviada a Perseo
                            </vs-button>
                        </div>
                    </div>
                </div>

                <!-- Estado de NC Completa -->
                <div v-if="ncYaGenerada" class="bg-green-50 border-2 border-green-300 rounded p-4 mb-4">
                    <div class="flex items-start justify-between">
                        <div>
                            <p class="text-green-700 font-bold mb-2">✓ Nota de Crédito Completada</p>
                            <p class="text-green-600 text-sm">Código: <span class="font-mono font-bold">{{ devolucionSeleccionada.nota_credito }}</span></p>
                            <!-- <p class="text-green-600 text-sm">Valor Total: ${{ parseFloat(totalesNotaCreditoGenerada.total_valor || 0).toFixed(2) }}</p> -->
                            <!-- <p class="text-green-600 text-sm">Ítems: {{ totalesNotaCreditoGenerada.total_items || 0 }}</p> -->
                            <p v-if="ncEnviadaAPerseo" class="text-sm text-blue-600 mt-2">
                                <!-- <strong>Enviada a Perseo:</strong> ID {{ devolucionSeleccionada.id_nota_credito_perseo }} -->
                            </p>
                        </div>
                        <vs-button
                            v-if="userRoot"
                            color="warning"
                            @click="mostrarDetallesNCGenerada"
                        >
                            Ver Detalles
                        </vs-button>
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" v-if="devolucionSeleccionada && !ncYaGenerada">
                    <div v-if="userRoot" class="bg-gray-50 p-3 rounded border border-gray-200">
                        <label class="block text-xs text-gray-600 mb-1">Empresa para Nota de Crédito</label>
                        <input
                            type="number"
                            class="w-full border rounded px-3 py-2 text-sm"
                            v-model.number="empresaPruebaNC"
                        >
                        <p class="text-xs text-gray-500 mt-2">Seleccione la empresa para esta NC.</p>
                    </div>
                    <div v-else class="bg-gray-50 p-3 rounded border border-gray-200">
                        <p class="text-xs text-gray-600 mb-1">Información</p>
                        <p class="text-sm text-gray-700">Empresa: {{ devolucionSeleccionada.empresa_id }}</p>
                        <p class="text-sm text-gray-700 mt-1">Solo root puede modificar cantidades. Puede revisar el JSON antes de confirmar.</p>
                    </div>
                </div>

                <div v-if="!ncYaGenerada" class="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4" v-show="totalesDetalleDevolucion">
                    <div class="bg-blue-50 p-3 rounded">
                        <p class="text-xs text-gray-600">Items devolución</p>
                        <p class="font-bold text-primary">{{ totalesDetalleDevolucion.total_items || 0 }}</p>
                    </div>
                    <div class="bg-green-50 p-3 rounded">
                        <p class="text-xs text-gray-600">Cantidad devolución</p>
                        <p class="font-bold text-success">{{ parseFloat(totalesDetalleDevolucion.total_cantidad || 0).toFixed(2) }}</p>
                    </div>
                    <div class="bg-orange-50 p-3 rounded">
                        <p class="text-xs text-gray-600">Valor devolución</p>
                        <p class="font-bold text-warning">${{ parseFloat(totalesDetalleDevolucion.total_valor || 0).toFixed(2) }}</p>
                    </div>
                    <div class="bg-red-50 p-3 rounded">
                        <p class="text-xs text-gray-600">Mismatches</p>
                        <p class="font-bold text-danger">{{ totalesDetalleDevolucion.total_mismatches || 0 }}</p>
                    </div>
                </div>

                <div v-if="!ncYaGenerada" class="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4" v-show="detallesDevolucionEdicion && detallesDevolucionEdicion.length > 0">
                    <div class="bg-slate-50 p-3 rounded border border-slate-200">
                        <p class="text-xs text-gray-600">Items NC</p>
                        <p class="font-bold text-primary">{{ totalesNotaCreditoPrueba.total_items || 0 }}</p>
                    </div>
                    <div class="bg-slate-50 p-3 rounded border border-slate-200">
                        <p class="text-xs text-gray-600">Cantidad NC</p>
                        <p class="font-bold text-success">{{ parseFloat(totalesNotaCreditoPrueba.total_cantidad || 0).toFixed(2) }}</p>
                    </div>
                    <div class="bg-slate-50 p-3 rounded border border-slate-200">
                        <p class="text-xs text-gray-600">Valor NC</p>
                        <p class="font-bold text-warning">${{ parseFloat(totalesNotaCreditoPrueba.total_valor || 0).toFixed(2) }}</p>
                    </div>
                    <div class="bg-slate-50 p-3 rounded border border-slate-200">
                        <p class="text-xs text-gray-600">Ítems incluidos</p>
                        <p class="font-bold text-dark">{{ totalesNotaCreditoPrueba.total_incluidos || 0 }}</p>
                    </div>
                </div>

                <div v-if="!ncYaGenerada && detallesDevolucionEdicion && detallesDevolucionEdicion.length > 0">
                    <table class="w-full table-auto">
                        <thead>
                            <tr class="text-left">
                                <th class="px-2 py-1">Incluir</th>
                                <th class="px-2 py-1">Código</th>
                                <th class="px-2 py-1">Nombre</th>
                                <th class="px-2 py-1">Cant. Dev.</th>
                                <th class="px-2 py-1">Código NC</th>
                                <th class="px-2 py-1">Cant. NC</th>
                                <th class="px-2 py-1">Precio</th>
                                <th class="px-2 py-1">Desc. %</th>
                                <th class="px-2 py-1">Subtotal</th>
                                <th class="px-2 py-1">Total NC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in detallesDevolucionEdicion" :key="item.id || item.pro_codigo" :class="{'bg-red-100': item._mismatch}">
                                <td class="px-2 py-1">
                                    <vs-checkbox color="success" v-model="item.incluir_nc" :disabled="!userRoot"></vs-checkbox>
                                </td>
                                <td class="px-2 py-1">{{ item.pro_codigo }}</td>
                                <td class="px-2 py-1">{{ item.pro_nombre || item.nombre_libro || '—' }}</td>
                                <td class="px-2 py-1">{{ parseFloat(item.cantidad_devolucion || item.cantidad || 0).toFixed(2) }}</td>
                                <td class="px-2 py-1" style="max-width: 160px;">
                                    <input
                                        v-if="userRoot"
                                        type="text"
                                        class="w-full border rounded px-2 py-1 text-sm"
                                        v-model.trim="item.pro_codigo_nc"
                                    >
                                    <span v-else>{{ item.pro_codigo_nc || item.pro_codigo }}</span>
                                </td>
                                <td class="px-2 py-1" style="max-width: 120px;">
                                    <input
                                        v-if="userRoot"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        class="w-full border rounded px-2 py-1 text-sm"
                                        v-model.number="item.cantidad_nc"
                                    >
                                    <span v-else>{{ parseFloat(item.cantidad_nc || 0).toFixed(2) }}</span>
                                </td>
                                <td class="px-2 py-1">${{ parseFloat(item.precio || item.det_ven_valor_u || 0).toFixed(2) }}</td>
                                <td class="px-2 py-1">{{ parseFloat(item.descuento || 0).toFixed(2) }}%</td>
                                <td class="px-2 py-1">${{ (parseFloat(item.cantidad_nc || 0) * parseFloat(item.precio || item.det_ven_valor_u || 0)).toFixed(2) }}</td>
                                <td class="px-2 py-1">${{ ((parseFloat(item.cantidad_nc || 0) * parseFloat(item.precio || item.det_ven_valor_u || 0)) * (1 - parseFloat(item.descuento || 0) / 100)).toFixed(2) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="!ncYaGenerada && detallesDevolucionEdicion && detallesDevolucionEdicion.length === 0" class="text-center py-8 text-gray-600">No hay detalles para esta devolución</div>

                <div v-if="previewNotaCreditoNC" class="mt-4 bg-gray-900 text-gray-100 rounded p-4">
                    <div class="flex items-center justify-between mb-2">
                        <h5 class="font-bold">Vista previa del payload</h5>
                        <span class="text-xs text-gray-300">Revise antes de enviar</span>
                    </div>
                    <pre class="text-xs overflow-auto whitespace-pre-wrap">{{ JSON.stringify(previewNotaCreditoNC, null, 2) }}</pre>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    name: 'ListaDevoluciones',
    props: {
        devolucionesFiltradas: {
            type: Array,
            default: () => []
        },
        devolucionesTotales: {
            type: Object,
            default: () => ({})
        },
        userRoot: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            devolucionSeleccionada: null,
            detallesDevolucion: [],
            detallesDevolucionEdicion: [],
            detallesDevolucionGenerada: [],
            showModalDevolucion: false,
            showModalNCPerseo: false,
            ncPerseoData: null,
            loadingGenerarNC: false,
            previewNotaCreditoNC: null,
            empresaPruebaNC: null,
            totalesDetalleDevolucion: {
                total_items: 0,
                total_cantidad: 0,
                total_valor: 0,
                total_mismatches: 0,
            },
            totalesNotaCreditoGenerada: {
                total_items: 0,
                total_cantidad: 0,
                total_valor: 0,
            },
        };
    },
    computed: {
        ncYaGenerada() {
            return this.devolucionSeleccionada && this.devolucionSeleccionada.nota_credito ? true : false;
        },

        ncEnviadaAPerseo() {
            return this.devolucionSeleccionada && this.devolucionSeleccionada.id_nota_credito_perseo ? true : false;
        },

        ncSinEnvioPerseo() {
            return false;
        },

        estadoNC() {
            if (!this.ncYaGenerada) return 'Sin generar';
            if (this.ncEnviadaAPerseo) return 'Enviada a Perseo';
            return 'Generada';
        },

        estadoNCClase() {
            if (!this.ncYaGenerada) return 'text-gray-600';
            if (this.ncEnviadaAPerseo) return 'text-blue-600 font-bold';
            return 'text-green-600 font-bold';
        },

        totalesNotaCreditoPrueba() {
            let me = this;
            let totalItems = 0;
            let totalCantidad = 0;
            let totalValor = 0;
            let totalIncluidos = 0;

            (me.detallesDevolucionEdicion || []).forEach(function(item) {
                if (item.incluir_nc) {
                    totalItems++;
                    totalCantidad += parseFloat(item.cantidad_nc) || 0;
                    totalValor += (parseFloat(item.cantidad_nc) * parseFloat(item.precio || item.det_ven_valor_u || 0)) || 0;
                    totalIncluidos++;
                }
            });

            return {
                total_items: totalItems,
                total_cantidad: totalCantidad,
                total_valor: totalValor.toFixed(2),
                total_incluidos: totalIncluidos,
            };
        }
    },
    methods: {
        abrirDevolucion(ven_codigo) {
            let me = this;
            me.loadingGenerarNC = true;
            me.previewNotaCreditoNC = null;
            me.detallesDevolucionEdicion = [];
            me.detallesDevolucionGenerada = [];
            me.sinEnvioPerseo = false;

            const url = `${me.$server_url}api/perseo/ventas-lista/devolucion-detalle?ven_codigo=${ven_codigo}`;

            me.$http.get(url)
                .then(res => {
                    if (res.data.status === 'success') {
                        me.devolucionSeleccionada = res.data.data.devolucion_base;
                        me.detallesDevolucion = res.data.data.detalles || [];
                        me.empresaPruebaNC = res.data.data.devolucion_base.empresa_id || null;

                        var totales = res.data.data.totales || {};
                        me.totalesDetalleDevolucion = {
                            total_items: (totales.total_items || 0),
                            total_cantidad: (totales.total_cantidad || 0),
                            total_valor: (totales.total_valor || 0),
                            total_mismatches: (totales.total_mismatches || 0),
                        };

                        // Si ya existe NC, cargar sus detalles
                        if (me.ncYaGenerada && res.data.data.detalles_nc) {
                            me.detallesDevolucionGenerada = res.data.data.detalles_nc;
                            var totalesNC = res.data.data.totales_nc || {};
                            me.totalesNotaCreditoGenerada = {
                                total_items: (totalesNC.total_items || 0),
                                total_cantidad: (totalesNC.total_cantidad || 0),
                                total_valor: (totalesNC.total_valor || 0),
                            };
                        } else {
                            me.inicializarEdicionNotaCredito();
                        }

                        me.showModalDevolucion = true;
                    } else {
                        me.$vs.notify({
                            title: 'Error',
                            text: res.data.message,
                            color: 'danger'
                        });
                    }
                })
                .catch(e => {
                    console.error('Error al cargar devolución:', e);
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al cargar la devolución',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    me.loadingGenerarNC = false;
                });
        },

        inicializarEdicionNotaCredito() {
            let me = this;

            me.detallesDevolucionEdicion = (me.detallesDevolucion || []).map(function(detalle) {
                const cantidadDev = parseFloat(detalle.cantidad_devolucion || detalle.cantidad || 0);
                const precio = parseFloat(detalle.precio || detalle.det_ven_valor_u || detalle.precio_venta || 0);
                const descuento = parseFloat(detalle.descuento || 0);
                
                return {
                    ...detalle,
                    incluir_nc: true,
                    pro_codigo_nc: detalle.pro_codigo,
                    cantidad_nc: cantidadDev,
                    precio: precio,
                    descuento: descuento,
                    subtotal_nc: cantidadDev * precio,
                };
            });
        },

        construirDetallesOverrideNC() {
            let me = this;
            return (me.detallesDevolucionEdicion || []).filter(d => d.incluir_nc).map(d => ({
                pro_codigo: d.pro_codigo_nc,
                cantidad: d.cantidad_nc,
                precio_unitario: d.precio,
                descuento: d.descuento || 0
            }));
        },

        ejecutarNotaCreditoDevolucion(enviar) {
            let me = this;
            me.loadingGenerarNC = true;

            const detallesNC = me.construirDetallesOverrideNC();

            if (detallesNC.length === 0 && enviar) {
                me.$vs.notify({
                    title: 'Advertencia',
                    text: 'Debes seleccionar al menos un detalle para la NC',
                    color: 'warning'
                });
                me.loadingGenerarNC = false;
                return;
            }

            const payload = {
                ven_codigo: me.devolucionSeleccionada.ven_codigo,
                empresa: me.empresaPruebaNC || me.devolucionSeleccionada.empresa_id,
                detalles_override: detallesNC,
                enviar: enviar,
                usuario_id: me.$store.state.usuario ? me.$store.state.usuario.idusuario : 0
            };

            const url = `${me.$server_url}api/perseo/ventas-lista/devolucion-nota-credito`;

            me.$http.post(url, payload)
                .then(res => {
                    if (enviar) {
                        var resumen = (res.data.resumen || {});
                        var procesadosOk = resumen.procesados_ok || 0;
                        if (res.data.status === 'success' || procesadosOk > 0) {
                            me.$vs.notify({
                                title: 'Éxito',
                                text: 'Nota de crédito generada exitosamente',
                                color: 'success'
                            });
                            me.$emit('nc-generada');
                            // Recargar datos para mostrar NC generada
                            setTimeout(() => {
                                me.abrirDevolucion(me.devolucionSeleccionada.ven_codigo);
                            }, 500);
                        } else {
                            me.$vs.notify({
                                title: 'Error',
                                text: res.data.message || 'Error al generar la NC',
                                color: 'danger'
                            });
                        }
                    } else {
                        me.previewNotaCreditoNC = res.data;
                    }
                })
                .catch(e => {
                    console.error('Error:', e);
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al procesar la NC',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    me.loadingGenerarNC = false;
                });
        },

        previsualizarNotaCreditoDevolucion() {
            this.ejecutarNotaCreditoDevolucion(false);
        },

        generarNotaCreditoDevolucion() {
            this.ejecutarNotaCreditoDevolucion(true);
        },

        enviarNCAPerseo() {
            let me = this;
            me.loadingGenerarNC = true;

            const payload = {
                ven_codigo: me.devolucionSeleccionada.ven_codigo,
                nota_credito: me.devolucionSeleccionada.nota_credito,
                usuario_id: me.$store.state.usuario ? me.$store.state.usuario.idusuario : 0
            };

            const url = `${me.$server_url}api/perseo/ventas-lista/enviar-nota-credito-perseo`;

            me.$http.post(url, payload)
                .then(res => {
                    if (res.data.status === 'success') {
                        me.$vs.notify({
                            title: 'Éxito',
                            text: 'Nota de crédito enviada a Perseo',
                            color: 'success'
                        });
                        me.devolucionSeleccionada.id_nota_credito_perseo = res.data.id_nota_credito_perseo || null;
                        me.$emit('nc-generada');
                    } else {
                        me.$vs.notify({
                            title: 'Error',
                            text: res.data.message || 'Error al enviar NC a Perseo',
                            color: 'danger'
                        });
                    }
                })
                .catch(e => {
                    console.error('Error:', e);
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al enviar NC a Perseo',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    me.loadingGenerarNC = false;
                });
        },

        mostrarDetallesNCGenerada() {
            let me = this;
            me.loadingGenerarNC = true;

            const url = `${me.$server_url}api/perseo/ventas-lista/consultar-nc-perseo?id_nota_credito_perseo=${me.devolucionSeleccionada.id_nota_credito_perseo}&empresa=${me.devolucionSeleccionada.empresa_id}`;

            me.$http.get(url)
                .then(res => {
                    if (res.data.status === 'success' && res.data.data) {
                        me.ncPerseoData = res.data.data;
                        me.showModalNCPerseo = true;
                    } else {
                        me.$vs.notify({
                            title: 'Error',
                            text: res.data.message || 'No se pudo consultar la NC en Perseo',
                            color: 'danger'
                        });
                    }
                })
                .catch(e => {
                    console.error('Error:', e);
                    me.$vs.notify({
                        title: 'Error',
                        text: 'Error al consultar NC en Perseo',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    me.loadingGenerarNC = false;
                });
        }
    }
};
</script>

<style scoped>
.w-full { width: 100%; }
.table-auto { width: 100%; border-collapse: collapse; }
.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }
.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-4 { margin-bottom: 1rem; }
.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-4 { margin-top: 1rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.flex { display: flex; }
.flex-wrap { flex-wrap: wrap; }
.flex-start { justify-content: flex-start; }
.items-start { align-items: flex-start; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }
.items-center { align-items: center; }
.border { border: 1px solid #e5e7eb; }
.border-2 { border-width: 2px; }
.rounded { border-radius: 0.375rem; }
.text-left { text-align: left; }
.text-center { text-align: center; }
.text-xs { font-size: 0.75rem; }
.text-sm { font-size: 0.875rem; }
.font-bold { font-weight: bold; }
.font-mono { font-family: monospace; }
.py-8 { padding-top: 2rem; padding-bottom: 2rem; }
.text-gray-600 { color: #4b5563; }
.text-gray-700 { color: #374151; }
.text-gray-100 { color: #f3f4f6; }
.text-gray-200 { color: #e5e7eb; }
.text-green-600 { color: #059669; }
.text-green-700 { color: #047857; }
.text-blue-600 { color: #2563eb; }
.bg-gray-50 { background-color: #f9fafb; }
.bg-gray-100 { background-color: #f3f4f6; }
.bg-gray-200 { background-color: #e5e7eb; }
.bg-gray-900 { background-color: #111827; }
.bg-blue-50 { background-color: #eff6ff; }
.bg-green-50 { background-color: #f0fdf4; }
.bg-green-100 { background-color: #dcfce7; }
.bg-orange-50 { background-color: #fffbeb; }
.bg-red-50 { background-color: #fef2f2; }
.bg-red-100 { background-color: #fee2e2; }
.bg-slate-50 { background-color: #f8fafc; }
.border-gray-200 { border-color: #e5e7eb; }
.border-green-300 { border-color: #86efac; }
.border-slate-200 { border-color: #e2e8f0; }
.text-primary { color: #0066cc; }
.text-success { color: #198754; }
.text-warning { color: #ffc107; }
.text-danger { color: #dc3545; }
.text-dark { color: #212529; }
.text-info { color: #0dcaf0; }
.whitespace-pre-wrap { white-space: pre-wrap; }
.overflow-auto { overflow: auto; }

@media (min-width: 768px) {
    .md\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .md\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
}
</style>
